module.exports = __webpack_public_path__ + "static/img/img10.dc44a4f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/jiameng/img10.jpg
// module id = F2Lf
// module chunks = 0